/* eslint-disable */
// @generated
// ⚠️ DO NOT EDIT THIS FILE MANUALLY!
// This file was automatically generated from Go structs and constants.
// Source package: github.com/future-ai-hotel/aionara/internal/foundation/web/render/ts_shared
// Regenerate: go generate ./...

export const JWTTokenParamName = "token";
export const ToastEventName = "toast";

export interface NotificationResponse {
  notification_type: string;
  message: string;
  notification_duration?: number;
}
export const NotificationTypeSuccess = "success";
export const NotificationTypeWarning = "warning";
export const NotificationTypeError = "error";
export const NotificationTypeInfo = "info";
